import { solidstate } from ":setup/qstate";
import DefaultLayout from "../SHARED/layouts/default-layout";
import * as accepted from "./apis/accepted";
import AcceptDetails from "./components/accepted-details";
import type { AcceptedDetails as AD } from "./_model";

export default function ConfirmAccount() {
  const $details = solidstate.create(null as AD);
  return (
    <DefaultLayout
      //
      // debug
      api={accepted.get}
      onValid={(details) => {
        $details.set(details);
      }}
    >
      <AcceptDetails details={$details.value} />
    </DefaultLayout>
  );
}
